import React, { useEffect, useState, useRef } from "react";
import styles from "./ProgressBar.module.css";

const ProgressBar = (props) => {
  const { calculationProgress } = props;

  const {
    calculationComplete,
    calculationSuccessful,
    calculationPending,
    currentStep,
    totalSteps,
    percentComplete,
    stepDescription,
    state,
  } = calculationProgress;

  const progressColors = {
    PENDING: "#737373",
    PROGRESS: "#67e8f9",
    SUCCESS: "#4ade80",
    FAILURE: "#ef4444",
  };

  const [barVisible, setBarVisible] = useState(false);
  const hideBarTimer = useRef(null); // keep track of the timer

  const hideBarHandler = ({ timeVisible = 5000 }) => {
    // Progress bar will be hidden after 5000 ms by default
    if (hideBarTimer.current) {
      clearTimeout(hideBarTimer.current); // clear the previous timer if it exists
    }
    hideBarTimer.current = setTimeout(() => {
      setBarVisible(false);
    }, timeVisible);
  };

  useEffect(() => {
    if (state === "SUCCESS" || state === "FAILURE") {
      hideBarHandler({ timeVisible: 10000 });
    } else if (state === "PENDING" || state === "PROGRESS") {
      if (hideBarTimer.current) {
        clearTimeout(hideBarTimer.current); // if the state is "PENDING" or "PROGRESS", we should cancel any existing timers
      }
      setBarVisible(true);
    } else if (state === "NOT STARTED") {
      hideBarHandler({ timeVisible: 5000 });
    }

    // Clean up function to clear timer when component unmounts or before re-render
    return () => {
      if (hideBarTimer.current) {
        clearTimeout(hideBarTimer.current);
      }
    };
  }, [state]);

  const getPercentComplete = () => {
    if (calculationComplete) {
      return 100;
    } else if (percentComplete < 5) {
      return 5;
    } else {
      return percentComplete;
    }
  };

  const getDescription = () => {
    if (state === "PENDING") {
      return "Calculation will start shortly...";
    } else if (state === "SUCCESS") {
      return "Calculation finished successfully!";
    } else if (state === "FAILURE") {
      return "An unexpected error occurred. Please retry. Consider retrying using different images.";
    } else {
      return stepDescription;
    }
  };

  return (
    <div
      className="flex flex-col items-center justify-start w-full mt-4 transition-all duration-500 Xbg-red-500
                 overflow-hidden
                "
      style={
        barVisible
          ? { height: "auto" }
          : { height: "0", padding: "0", margin: "0" }
      }
    >
      <div className="flex flex-row items-center justify-start w-full pb-1">
        <p className=" text-xl font-medium text-neutral-900">
          {getDescription()}
        </p>
      </div>
      <div className="flex flex-row items-start justify-center w-full bg-neutral-200 rounded-lg overflow-hidden">
        <div
          className={styles["progress-bar-loader"]}
          style={{
            clipPath: `polygon(0 0, ${getPercentComplete()}% 0, ${getPercentComplete()}% 100%, 0 100%)`,
            backgroundImage: `linear-gradient(
                              45deg,
                              ${progressColors[state]} 25%,
                              transparent 25%,
                              transparent 50%,
                              ${progressColors[state]} 50%,
                              ${progressColors[state]} 75%,
                              transparent 75%,
                              transparent
                          )`,
          }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;
